/**
 * Created by Suhel Shrestha on 4/3/19
 */
import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

@observer
class ExportHeirTable extends React.Component {

  @observable selectAll = false;

  render() {
    const { data, forCheckBox, onChangeCheck, onClickExpandCollapse } = this.props;
    return (
      <div className="HierTable">
        <table>
          <thead>
            <tr>
              <th>{''}</th>
              <th>Name</th>
              <th>
                <input type='checkbox' onChange={() => {
                  this.selectAll = !this.selectAll;
                  data.forEach((item, index) => {
                    onChangeCheck(index, this.selectAll);
                  })
                }} />
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((cb, index) => {
              let prevExpanded, caretDown = false, caretRight = false;
              if (cb.level === 1) {
                prevExpanded = forCheckBox.filter(x => x.folderId === cb.id)[0].expanded;
                caretDown = cb.level === 1 && prevExpanded;
                caretRight = cb.level === 1 && !prevExpanded;
              }

              const display = cb.level === 1 || (cb.level === 2 && forCheckBox.filter(fcb => fcb.folderId === cb.parent_id)[0].expanded);

              if (!display) {
                return;
              }

              return (
                <tr className={`level-${cb.level}`} key={cb.key}>
                  <td className="caret" onClick={() => onClickExpandCollapse(cb)}>
                    {caretDown && <i className="fa fa-caret-down" aria-hidden="true" />}
                    {caretRight && <i className="fa fa-caret-right" aria-hidden="true" />}
                  </td>
                  <td onClick={onClickExpandCollapse}>{cb.name} {cb.level === 1 && '(' + data.filter(data => data.parent_id === cb.id).length + ')'}</td>
                  <td><input type="checkbox"
                    onChange={() => onChangeCheck(index)}
                    value={forCheckBox.filter(cbitem => {
                      let cid = cb.level === 1 ? cbitem.folderId : cbitem.stationId;
                      return (cid === cb.id)
                    })[0].selected}
                    checked={forCheckBox.filter(cbitem => {
                      let cid = cb.level === 1 ? cbitem.folderId : cbitem.stationId;
                      return (cid === cb.id)
                    })[0].selected} /></td>
                </tr>
              );

            })}
          </tbody>
        </table>
      </div>
    )
  }
}

export default ExportHeirTable;


// WEBPACK FOOTER //
// ./src/components/Folder/StationExport/ExportHeirTable.js